module.exports = __webpack_public_path__ + "static/img/zhuqianru.9d03eff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/people/zhuqianru.jpg
// module id = RFYd
// module chunks = 2